export class Transponder {
  private static transpondMap : { [index: string]: {prev: string, next: string}} = {
    'C': {prev: 'B', next: 'C#'},
    'C#': {prev: 'C', next: 'D'},
    'D': {prev: 'C#', next: 'D#'},
    'D#': {prev: 'D', next: 'E'},
    'E': {prev: 'D#', next: 'F'},
    'F': {prev: 'E', next: 'F#'},
    'F#': {prev: 'F', next: 'G'},
    'G': {prev: 'F#', next: 'G#'},
    'G#': {prev: 'G', next: 'A'},
    'A': {prev: 'G#', next: 'A#'},
    'A#': {prev: 'A', next: 'B'},
    'B': {prev: 'A#', next: 'C'}
  };
  public static transpond(chord: string, steps: number = 0): string {
    if (steps === 0) {
      return chord;
    }
    const c = Transponder.transpond(chord, steps + (steps < 0 ? 1 : -1));
    const base = c.charAt(0) + (c.length > 1 && c.charAt(1) === '#' ? '#' : '');
    if (!Transponder.transpondMap[base]) {
      return 'U' + c.slice(base.length);
    }
    const mapping = Transponder.transpondMap[base];
    return (steps > 0 ? mapping.next : mapping.prev) + c.slice(base.length);
  }
}
